export default "__VITE_ASSET__XCTfnwm1__"